import { Reducer } from "@reduxjs/toolkit";
import { SegurancaNoTrabalhoState, SegurancaNoTrabalhoTypes } from "./types";

const INITIAL_STATE: SegurancaNoTrabalhoState = {
    data: {
        table: null,
        segurancaNoTrabalho: null
    },
    error: false,
    errorMessage: null,
    loading: false,
    loadingTable: false,
    loadingPersis: false,
    loadingInativacao: false,
};

const reducer: Reducer<SegurancaNoTrabalhoState> = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SegurancaNoTrabalhoTypes.SEGURANCA_TABLE_REQUEST:
            return {
                ...state,
                error: false,
                loadingTable: true,
            };
        case SegurancaNoTrabalhoTypes.SEGURANCA_TABLE_REQUEST_SUCCESS:
            return {
                ...state,
                error: false,
                loadingTable: false,
                data: {
                    ...state.data,
                    table: action.payload.data
                }
            };
        case SegurancaNoTrabalhoTypes.SEGURANCA_TABLE_REQUEST_FAILURE:
            return {
                ...state,
                error: true,
                loadingTable: false,
                errorMessage: action.payload.err,
                data: {
                    ...state.data,
                    table: null
                }
            };

        case SegurancaNoTrabalhoTypes.SEGURANCA_INATIVA_REQUEST:
            return {
                ...state,
                error: false,
                loading: true,
                loadingInativacao: true,
            };
        case SegurancaNoTrabalhoTypes.SEGURANCA_INATIVA_REQUEST_SUCCESS:
            alert('Ação realizada com sucesso!');
            return {
                ...state,
                error: false,
                loading: false,
                loadingInativacao: false,
            };
        case SegurancaNoTrabalhoTypes.SEGURANCA_INATIVA_REQUEST_FAILURE:
            return {
                ...state,
                error: true,
                loading: false,
                loadingInativacao: false,
                errorMessage: action.payload.err,
            };

        case SegurancaNoTrabalhoTypes.SEGURANCA_ATIVA_REQUEST:
            return {
                ...state,
                error: false,
                loading: true,
                loadingInativacao: true,
            };
        case SegurancaNoTrabalhoTypes.SEGURANCA_ATIVA_REQUEST_SUCCESS:
            alert('Ação realizada com sucesso!');
            return {
                ...state,
                error: false,
                loading: false,
                loadingInativacao: false,
            };
        case SegurancaNoTrabalhoTypes.SEGURANCA_ATIVA_REQUEST_FAILURE:
            return {
                ...state,
                error: true,
                loading: false,
                loadingInativacao: false,
                errorMessage: action.payload.err,
            };

        case SegurancaNoTrabalhoTypes.SEGURANCA_DATA_REQUEST:
            return {
                ...state,
                error: false,
                loading: true,
            };
        case SegurancaNoTrabalhoTypes.SEGURANCA_DATA_REQUEST_SUCCESS:
            return {
                ...state,
                error: false,
                loading: false,
                data: {
                    ...state.data,
                    segurancaNoTrabalho: action.payload.data
                }
            };
        case SegurancaNoTrabalhoTypes.SEGURANCA_DATA_REQUEST_FAILURE:
            return {
                ...state,
                error: true,
                loading: false,
                errorMessage: action.payload.err,
                data: {
                    ...state.data,
                    segurancaNoTrabalho: null
                }
            };


        case SegurancaNoTrabalhoTypes.CLEAR_SEGURANCA_DATA:
            return {
                ...state,
                error: false,
                loading: false,
                data: {
                    ...state.data,
                    segurancaNoTrabalho: null
                }
            };

        case SegurancaNoTrabalhoTypes.SEGURANCA_SAVE_REQUEST:
            return {
                ...state,
                error: false,
                loadingPersis: true,
            };
        case SegurancaNoTrabalhoTypes.SEGURANCA_SAVE_REQUEST_SUCCESS:
            alert('Cadastro de Segurança do Trabalho realizado com sucesso!');
            return {
                ...state,
                error: false,
                loadingPersis: false,
                data: {
                    ...state.data,
                    segurancaNoTrabalho: action.payload.data
                }
            };
        case SegurancaNoTrabalhoTypes.SEGURANCA_SAVE_REQUEST_FAILURE:
            return {
                ...state,
                error: true,
                loadingPersis: false,
                errorMessage: action.payload.err,
            };

        case SegurancaNoTrabalhoTypes.SEGURANCA_UPDATE_REQUEST:
            return {
                ...state,
                error: false,
                loadingPersis: true,
            };
        case SegurancaNoTrabalhoTypes.SEGURANCA_UPDATE_REQUEST_SUCCESS:
            alert('Edição de Segurança do Trabalho realizado com sucesso!');
            return {
                ...state,
                error: false,
                loadingPersis: false,
                data: {
                    ...state.data,
                    segurancaNoTrabalho: action.payload.data
                }
            };
        case SegurancaNoTrabalhoTypes.SEGURANCA_UPDATE_REQUEST_FAILURE:
            return {
                ...state,
                error: true,
                loadingPersis: false,
                errorMessage: action.payload.err,
            };

        case SegurancaNoTrabalhoTypes.SEGURANCA_PUSH_REQUEST:
            return {
                ...state,
                error: false,
                loading: true,
            };
        case SegurancaNoTrabalhoTypes.SEGURANCA_PUSH_REQUEST_SUCCESS:
            alert('As notificações entraram na fila para envio! Pode levar alguns minutos para que os usuários recebam.');
            return {
                ...state,
                error: false,
                loading: false,
            };
        case SegurancaNoTrabalhoTypes.SEGURANCA_PUSH_REQUEST_FAILURE:
            return {
                ...state,
                error: true,
                loading: false,
                errorMessage: action.payload.err,
            };

        default :
            return {
    ...state,
    error: false,
    loading: false,
    errorMessage: null
};
    }
};

export default reducer;